// import {
//   HomeIcon,
//   ExploreIcon,
//   SideNavQuestionMarkIcon,
//   UserIcon,
//   ZaidynLogo,
//   SurveyQuestionsIcon,
//   BespokeInsightIcon
// } from "../assets/icons/svg";
// import { logout } from "../services/ExperienceBankAPI";

// import Icon, { MailOutlined } from "@ant-design/icons";
// import React from "react";
// import "./Home.scss";
// import { Dropdown, Tooltip } from "antd";

// const logoutClick = async () => {
//   try {
//     //sessionStorage.setItem("loggedout", "yes");
//     const payload = {
//       user_id: localStorage.getItem("user_id"),
//       logout_from: "logout",
//     };

//     await logout(payload); // Replace with your actual API call
//     sessionStorage.removeItem('sessionId');

//     window.location.replace(`${process.env.REACT_APP_IDM_LOGOUT_URL}`);
//   } catch (error) {
//     console.error("Error during logout:", error);
//     // Handle error as needed
//   }
// };

// export const ProductLogo = [
//   {
//     key: "zaidynLogo",
//     value: (
//       <React.Fragment>
//         <div>
//           {/* <Icon style={{ display: "inline-block" }} component={ZaidynLogo} /> */}
//           <Icon component={ZaidynLogo} />
//         </div>
//       </React.Fragment>
//     ),
//   },
// ]

// export const SideNavBarData = [

//   {
//     key: "/explore", //remove space after explore
//     value: (
//       <React.Fragment>
//         <div>
//           <Icon component={ExploreIcon} />
//         </div>
//         <div className="navBarItems">
//           <span>Explore</span>
//         </div>
//       </React.Fragment>
//     ),
//   },
//   {
//     key: "/analysis-library",
//     value: (
//       <React.Fragment>
//         <div>
//           <Icon component={HomeIcon} />
//         </div>
//         <div className="navBarItems">
//           <span>
//             Filter and <br /> Export <br />
//             Library
//           </span>
//         </div>
//       </React.Fragment>
//     ),
//   },
//   {
//     key: "/survey-questions",
//     value: (
//       <React.Fragment>
//         <div>
//           <Icon component={SurveyQuestionsIcon} />
//         </div>
//         <div className="navBarItems">
//           <span>
//             Survey <br /> Questions
//           </span>
//         </div>
//       </React.Fragment>
//     ),
//   },
//   {
//     key: "/bespoke-insights",
//     value: (
//       <React.Fragment>
//         <div>
//           <Icon component={BespokeInsightIcon} />
//         </div>
//         <div className="navBarItems">
//           <span>
//             Bespoke <br /> Insights
//           </span>
//         </div>
//       </React.Fragment>
//     ),
//   },
//   // YS-FAQ change enable this 
//   // {
//   //   key: "/faq",
//   //   value: (
//   //     <React.Fragment>
//   //         <Tooltip
//   //           placement="right"
//   //           title="FAQ's">
//   //           {/* <strong>{record[`total_questions_percent${index + 1}`]}%</strong> */}
                 
//   //       <div>
//   //       <Icon component={SideNavQuestionMarkIcon}/>
//   //       </div>
      
//   //       </Tooltip>
//   //     </React.Fragment>
//   //   ),
//   // },
//   {
//     key: "/getMoreInsights",
//     value: (
//       <React.Fragment>
//           <Tooltip
//             placement="right"
//             title="Get More Insights">
//             {/* <strong>{record[`total_questions_percent${index + 1}`]}%</strong> */}
                 
//         <div>
//         {/* <Icon component={SideNavQuestionMarkIcon}/> */}
//         <MailOutlined style={{ fontSize: 25,marginTop:10}} />
//         </div>
      
//         </Tooltip>
//       </React.Fragment>
//     ),
//   },
// ];

// const items = [
//   {
//     key: "1",
//     label: (
//       <a
//         target="_self"
//         rel="noopener noreferrer"
//         className="dropdown-link"
//         href={process.env.REACT_APP_IDM_MY_ACCOUNT_URL}
//       >
//         My Account
//       </a>
//     ),
//   },
//   {
//     key: "2",
//     label: (
//       <a
//         target="_self"
//         rel="noopener noreferrer"
//         className="dropdown-link"
//         onClick={logoutClick}
//         href={process.env.REACT_APP_IDM_LOGOUT_URL}
//       >
//         Logout
//       </a>
//     ),
//   },
// ];

// export const setting = [
//   {
//     key: "user",
//     value: (
//       <React.Fragment>
//         <div>
//           <Dropdown
//             menu={{
//               items,
//             }}
//             trigger={"click"}
//           >
//             <Icon component={UserIcon} />
//           </Dropdown>
//         </div>
//       </React.Fragment>
//     ),
//   },
 
//   // {
//   //   key: "/faq",
//   //   value: (
//   //     <React.Fragment>
//   //         <Tooltip
//   //                   placement="right"
//   //                   title="FAQ">
//   //                   {/* <strong>{record[`total_questions_percent${index + 1}`]}%</strong> */}
                 
//   //       <div>
//   //       <Icon component={SideNavQuestionMarkIcon}/>
//   //       </div>
      
//   //       </Tooltip>
//   //     </React.Fragment>
//   //   ),
//   // },
// ];









import {
  HomeIcon,
  ExploreIcon,
  UserIcon,
  ZaidynLogo,
  SurveyQuestionsIcon,
  BespokeInsightIcon,
} from "../assets/icons/svg";
import { logout } from "../services/ExperienceBankAPI";

import Icon, { MailOutlined, LoadingOutlined ,UserAddOutlined  } from "@ant-design/icons";
import React, { useState } from "react";
import "./Home.scss";
import { Dropdown, Tooltip, Spin, notification } from "antd";
const userInfo = JSON.parse(localStorage.getItem("userInfo"));
const environment = userInfo?.environment || "";

const UserDropdown = () => {
  const [logoutLoading, setLogoutLoading] = useState(false);

  const logoutClick = async (e) => {
    e.domEvent.preventDefault();

    if (logoutLoading) return;

    setLogoutLoading(true);

    notification.info({
    key: "logout-progress",
    message: "Logging out",
    description: "Please wait while we sign you out.",
    icon: <LoadingOutlined spin />, // still works
    duration: 0,
  });

    try {
      const payload = {
        user_id: localStorage.getItem("user_id"),
        logout_from: "logout",
      };

      await logout(payload);

      sessionStorage.removeItem("sessionId");

      notification.success({
        key: "logout-progress",
        message: "Logged out successfully",
        description: "Redirecting now...",
        placement: "topRight",
        duration: 1,
      });

      setTimeout(() => {
        window.location.replace(process.env.REACT_APP_IDM_LOGOUT_URL);
      }, 500);
    } catch (error) {
      console.error("Error during logout:", error);

      setLogoutLoading(false);

      notification.error({
        key: "logout-progress",
        message: "Logout failed",
        description: "Something went wrong while logging out. Please try again.",
        placement: "topRight",
        duration: 4,
      });
    }
  };

  const items = [
    {
      key: "1",
      label: (
        <a
          target="_self"
          rel="noopener noreferrer"
          className="dropdown-link"
          href={process.env.REACT_APP_IDM_MY_ACCOUNT_URL}
        >
          My Account
        </a>
      ),
    },
    {
      key: "2",
      label: (
        <span
          className="dropdown-link"
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            cursor: logoutLoading ? "not-allowed" : "pointer",
            opacity: logoutLoading ? 0.6 : 1,
            pointerEvents: logoutLoading ? "none" : "auto",
          }}
        >
          {logoutLoading ? (
            <Spin indicator={<LoadingOutlined style={{ fontSize: 14 }} spin />} />
          ) : null}
          {logoutLoading ? "Logging out..." : "Logout"}
        </span>
      ),
      onClick: logoutLoading ? undefined : logoutClick,
    },
  ];

  return (
    <Dropdown menu={{ items }} trigger={["click"]}>
      <span style={{ cursor: "pointer", display: "inline-flex" }}>
        <Icon component={UserIcon} />
      </span>
    </Dropdown>
  );
};

export const ProductLogo = [
  {
    key: "zaidynLogo",
    value: (
      <div>
        <Icon component={ZaidynLogo} />
      </div>
    ),
  },
];

export const SideNavBarData = [
  {
    key: "/explore",
    value: (
      <>
        <div>
          <Icon component={ExploreIcon} />
        </div>
        <div className="navBarItems">
          <span>Explore</span>
        </div>
      </>
    ),
  },
  {
    key: "/analysis-library",
    value: (
      <>
        <div>
          <Icon component={HomeIcon} />
        </div>
        <div className="navBarItems">
          <span>
            Filter and <br /> Export <br />
            Library
          </span>
        </div>
      </>
    ),
  },
  {
    key: "/survey-questions",
    value: (
      <>
        <div>
          <Icon component={SurveyQuestionsIcon} />
        </div>
        <div className="navBarItems">
          <span>
            Survey <br /> Questions
          </span>
        </div>
      </>
    ),
  },
  {
    key: "/bespoke-insights",
    value: (
      <>
        <div>
          <Icon component={BespokeInsightIcon} />
        </div>
        <div className="navBarItems">
          <span>
           {environment === "prod_client_1"?"ELVIA":"PXB 3.0"} 
          </span>
        </div>
      </>
    ),
  },
  {
  key: "/userDetails",
  value: (
    <Tooltip placement="right" title="Add User">
      <div>
        <UserAddOutlined style={{ fontSize: 25, marginTop: 10 }} />
      </div>
    </Tooltip>
  ),
},
  {
    key: "/getMoreInsights",
    value: (
      <Tooltip placement="right" title="Get More Insights">
        <div>
          <MailOutlined style={{ fontSize: 25, marginTop: 10 }} />
        </div>
      </Tooltip>
    ),
  },
];

export const setting = [
  {
    key: "user",
    value: (
      <div>
        <UserDropdown />
      </div>
    ),
  },
];